import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";
import Layout from "../../../components/Layout/Layout";
import Therapist from "../../../components/Therapist/Therapist";

// markup
const name = "Jennifer Gleason-Wilson";
const license = "MA, LPC";
const areas = [
  "ADHD Support",
  "Anxiety Relief",
  "Depression Management",
  "Goal-oriented Growth",
  "Leadership Development",
  "Life Transitions",
];

const IndexPage = () => (
  <Layout full={true} removeTopSpace={true} className="bg-yellow-50">
    <Therapist
      name={name}
      license={license}
      areas={areas}
      photo={
        <StaticImage
          src="./jennifer-gleason-wilson-2.jpeg"
          alt={name}
          layout="fullWidth"
          className="shadow"
        />
      }
    >
      <p>
        Life can often feel like a series of overwhelming demands that can leave
        you feeling depleted, disconnected or stuck. With over 25 years of
        experience as a Licensed Professional Counselor, Jennifer believes that
        therapy is most effective as a collaborative process. She partners with
        clients, working mainly with adults, to develop practical, actionable
        steps tailored to individual goals in a supportive, growth-oriented
        space.
      </p>
      <p>
        Jennifer integrates symptom management with a relational, systems-based
        approach into her practice. This method views current symptoms as clues
        to uncovering behavioral patterns, allowing individuals to make more
        intentional choices in their daily lives and relationships.
      </p>
      <p className="font-semibold text-green-900">Areas of focus:</p>
      <ul className="list-disc space-y-2 pl-6">
        <li>
          <span className="font-semibold">ADHD support:</span> Identify
          executive function functioning hurdles and develop strategies to
          master them.
        </li>
        <li>
          <span className="font-semibold">Anxiety Relief:</span> Quieting the
          constant &ldquo;noise,&rdquo; managing chronic worry, and regulating
          nervous system responses.
        </li>
        <li>
          <span className="font-semibold">Depression Management:</span>{" "}
          Navigating the heavy fog, restoring motivation, and desired daily
          functioning.
        </li>
        <li>
          <span className="font-semibold">Goal-oriented Growth:</span>{" "}
          Transforming overwhelming life demands into structured, achievable
          steps for personal success.
        </li>
        <li>
          <span className="font-semibold">Leadership Development:</span> Explore
          and define your leadership style that is based out of your guiding
          principles and values.
        </li>
        <li>
          <span className="font-semibold">Life Transitions:</span> Overcoming
          feelings of being stuck during major career, relationship, or
          lifestyle changes.
        </li>
      </ul>
    </Therapist>
  </Layout>
);

export default IndexPage;
